import UpdateTerminalModal from "./UpdateTerminalModal";

export default UpdateTerminalModal;